import { componentProvider } from 'js-component-framework/es';
import breakpoints from '@/js/utils/breakpoints';
import PopOver from '@/js/PopOver';

/**
 * MenuBarButton component.
 */
class MenuBarButton {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
    breakpoints.lgMin.addEventListener('change', this.init);
  }

  /**
   * Set up the PopOver.
   */
  init() {
    if (!breakpoints.lgMin.matches) {
      // Init for small screens.
      if (this.menuButton instanceof PopOver) {
        this.menuButton.init();
      } else {
        this.menuButton = new PopOver(this.element, this.options);
      }
    } else if (this.menuButton instanceof PopOver) {
      // Destroy for large screens.
      this.menuButton.destroy();
    }
  }
}

const menuBarButtonConfig = {
  name: 'menu-bar-button',
  component: MenuBarButton,
};

componentProvider(menuBarButtonConfig);
